module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAANlBMVEUAAAAWqPEUqfEarPcVqfEVqfEVrvUUqfAWqfEUqvMUqfEYq/MUqfEVqfEUqfEVqv8rqv8UqPDCv846AAAAEXRSTlMAgX8deOYYu6Y/90CZ59gMBqNIvvEAAABkSURBVCjPtZFLDoAwCERRKNZaP9z/shKbxkTH1E0nYcML36HZnlro0jhQVU10AWgDB7jsH8gWIiNgrBIYAQ+JH0BDG7RbuVTW93CeEl53kgMfmHayG5T/baVCDb7YZ+ReNmIHT4VBBjld97EVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/homeSVG/ofd_to_pdf_hover.png
// module id = 03f3
// module chunks = 2